import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, SERVICES } from '../constants';
import { Phone, Mail, MapPin, Facebook, Linkedin, Instagram, Twitter, ShieldCheck } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Preciseo Tax Services" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white/60 font-medium leading-relaxed">
              IRS Enrolled Agents providing accurate, compliant, and secure tax filing services for individuals and businesses nationwide.
            </p>
            <div className="flex items-center space-x-2 text-secondary">
              <ShieldCheck size={20} />
              <span className="text-sm font-bold">IRS Authorized</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-black text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/60 hover:text-secondary transition-colors font-medium">About Us</Link></li>
              <li><Link to="/services" className="text-white/60 hover:text-secondary transition-colors font-medium">Our Services</Link></li>
              <li><Link to="/forms-links" className="text-white/60 hover:text-secondary transition-colors font-medium">Forms & Links</Link></li>
              <li><Link to="/faqs" className="text-white/60 hover:text-secondary transition-colors font-medium">FAQs</Link></li>
              <li><Link to="/blogs" className="text-white/60 hover:text-secondary transition-colors font-medium">Blog</Link></li>
              <li><Link to="/contact" className="text-white/60 hover:text-secondary transition-colors font-medium">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-black text-lg mb-6">Services</h3>
            <ul className="space-y-3">
              {SERVICES.slice(0, 6).map((service) => (
                <li key={service.id}>
                  <Link to={`/services/${service.id.replace('-filing', '-tax-filing').replace('fbar-fbar', 'fbar-fatca').replace('itin-app', 'itin-application')}`} className="text-white/60 hover:text-secondary transition-colors font-medium">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-black text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-secondary mr-3 mt-1 shrink-0" />
                <span className="text-white/60 font-medium">{COMPANY_INFO.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 text-secondary mr-3 shrink-0" />
                <a href={`tel:${COMPANY_INFO.phone}`} className="text-white/60 hover:text-secondary transition-colors font-medium">{COMPANY_INFO.phone}</a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 text-secondary mr-3 shrink-0" />
                <a href={`mailto:${COMPANY_INFO.email}`} className="text-white/60 hover:text-secondary transition-colors font-medium">{COMPANY_INFO.email}</a>
              </li>
            </ul>
            
            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href={COMPANY_INFO.socials.facebook} className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors">
                <Facebook size={18} />
              </a>
              <a href={COMPANY_INFO.socials.linkedin} className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors">
                <Linkedin size={18} />
              </a>
              <a href={COMPANY_INFO.socials.instagram} className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors">
                <Instagram size={18} />
              </a>
              <a href={COMPANY_INFO.socials.twitter} className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors">
                <Twitter size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/40 text-sm font-medium">
              © {new Date().getFullYear()} {COMPANY_INFO.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/" className="text-white/40 hover:text-secondary transition-colors font-medium">Privacy Policy</Link>
              <Link to="/" className="text-white/40 hover:text-secondary transition-colors font-medium">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;